import { Select } from 'antd';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { setCookie } from '../http/cookie';
import state from '../state';
import { selectLocales, setCurLocale } from './store';

const Locale = () => {

    const loc = useLocation();

    const navigate = useNavigate();

    const locales = useSelector(selectLocales);

    const dispatch = useDispatch();

    const [locale, setLocale] = React.useState(state.locale);

    React.useEffect(() => {
        const search = new URLSearchParams(loc.search);
        const queryLocale = search.get('locale');
        if (queryLocale && locales.find(l => l.name === queryLocale)) {
            setLocale(queryLocale);
        }
    }, [loc.search, locales]);

    React.useEffect(() => {
        state.locale = locale;
        dispatch(setCurLocale(locale));
        setCookie('locale', locale);
    }, [locale])

    return locales?.length ? (
        <Select
            style={{width: '5em'}}
            value={locale}
            options={locales.map(l => ({
                value: l.name,
                label: l.label,
            }))}
            onChange={val => {
                const search = new URLSearchParams(loc.search);
                search.set('locale', val);
                navigate(`${loc.pathname}?${search.toString()}${loc.hash}`, {replace: true});
                location.reload();
            }}
        />
    ) : null;
}

export default Locale;
